<div class="card">
  <div class="card-header">
    {{pageTitle}}
  </div>
  <div class="card-body">
    <div class="container-fluid">
      <div class="text-center">
        <img src="./assets/images/logo.jpg"
             class="img-responsive center-block"
             style="max-height:300px;padding-bottom:50px" />
      </div>

      <div class="text-center">Developed by:</div>
      <div class="text-center">
        <h3>Deborah Kurata</h3>
      </div>

      <div class="text-center">@deborahkurata</div>
      <div class="text-center">
        <a href="http://www.bit.ly/DeborahKsBlog">www.bit.ly/DeborahKsBlog</a>
      </div>
    </div>
  </div>
</div>